import { Controller } from "@hotwired/stimulus"

// Keeps a submit button disabled until a confirmation checkbox is checked.
export default class extends Controller {
  static targets = ["box", "submit"]

  connect() {
    this.sync()
  }

  sync() {
    this.submitTarget.disabled = !this.boxTarget.checked
  }
}
